var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBell = function SvgBell(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 20C24 16.3 24 7.8 17.1 7.1C17.4 6.8 17.5 6.5 17.5 6C17.5 5.2 16.8 4.5 16 4.5C15.2 4.5 14.5 5.2 14.5 6C14.5 6.4 14.7 6.8 14.9 7.1C8 7.8 8 16.3 8 20C8 22.8 5.5 23 5 23V25H12.1C12.4 26.8 13.4 29 16 29C18.6 29 19.6 26.8 19.9 25H27V23C26.5 23 24 22.8 24 20ZM16 27C14.8 27 14.3 25.9 14.1 25H17.9C17.7 25.9 17.2 27 16 27ZM10 20C10 21.3 9.6 22.3 9.1 23H22.9C22.3 22.3 22 21.3 22 20C22 14.7 21.5 9 16 9C10.5 9 10 14.7 10 20Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBell);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "bell.0ed610477a6c97972fe6c3761a53c0d9.svg";